import { transformEventItems } from "$lib/utilities/calendar";
import { groupEventsByDay } from "$lib/utilities/eventSchedule";

export let resizeParams = {};

export const EPL_FORM_FACTORS = {
  GRID: "Calendar Grid",
  LIST: "Calendar List",
  SCHEDULE: "Event Schedule"
};

export const getThemedItemIds = (themeObject) => {
  if (themeObject) {
    return themeObject.map((themedItem) => {
      return themedItem.sys?.id;
    });
  }
  return [];
};

export const transformListItems = ({
  items = [],
  themedItems = [],
  featuredItems = [],
  excludedItems = [],
  maxItems = 4,
  showMonth,
  formFactor
}) => {
  // Limit to 1 featured item
  const featuredEvents = featuredItems.map((item) => item.fields).slice(0, 1);
  const featuredColumnCount = featuredEvents.length * 2;
  // Remove excluded and featured items from the main list and limit to maxItems
  const events = items
    .filter(
      (item) =>
        !excludedItems.some((excluded) => excluded.sys?.id === item.sys?.id) ||
        !featuredItems.some((featured) => featured.sys?.id === item.sys?.id)
    )
    .slice(0, formFactor === EPL_FORM_FACTORS.SCHEDULE ? undefined : maxItems - featuredColumnCount) // Account for 2 columns if featured item exists. No maxItems limit for schedule view.
    .map((item) => {
      return { ...item.fields, contentType: item.sys?.contentType?.sys?.id } || {};
    })
    .sort((a, b) => new Date(a.start) - new Date(b.start));

  return {
    days: groupEventsByDay([...events, ...featuredEvents]),
    items: transformEventItems({ items: events, themedItems, showMonth }),
    featuredItems: transformEventItems({ items: featuredEvents })
  };
};
